import React, {useState, useEffect} from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import {lobbySelection} from '../Assets/variables';
import {isMobile} from 'react-device-detect';
import {report, getReportParams} from '../../../../middleware/report';
import Image from '../../../Shared/Image/image';
import EnterIdPartial from '../Assets/enterIdPartial';
import { LogoHelper, LogoType } from 'app/utilities/LogoHelper/helper';

const IdInsert = (props) => {
  const [idNumber, setIdNumber] = useState('');
  const [errorInForm, setErrorForm] = useState(null);
  const [moreInfo, setMoreInfo] = useState(false);
  const [isPassportInsert, setPassportInsert] = useState(false);

  const mainLogo = LogoHelper.getLogo(LogoType.MainLogo);

  useEffect(() => {
    let reportParams = {};
    reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'NEW_OTP';
    reportParams.channel = 'WebsitePrivate';
    reportParams.actionType = 'Entered Id Completion';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Entered Id Completion';
    reportParams.subscriber = props.loginData?.userDetails?.contactNumber;
    report(reportParams);
  }, []);

  function is_israeli_id_number(id) {
    id = String(id).trim();
    if (id.length > 9 || isNaN(id)) return false;
    id = id.length < 9 ? ('00000000' + id).slice(-9) : id;
    return (
      Array.from(id, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) %
        10 ===
      0
    );
  }
  const changeIdType = (val) => {
    setPassportInsert(val);
    setIdNumber('');
  };

  const validateId = async () => {
    const idPattern = /^\d{9}$/;
    const passportPattern = /^[A-Za-z0-9]{6,12}$/;
    setMoreInfo(false);
    setErrorForm(null);
    if (isPassportInsert && !passportPattern.test(idNumber)) {
      setErrorForm('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
    } else {
      if (!isPassportInsert && (!idPattern.test(idNumber) || !is_israeli_id_number(idNumber))) {
        setErrorForm('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
      } else {
        let idIsCorrect = await props.onclick(idNumber);
        if (!idIsCorrect) {
          setMoreInfo(true);
        }
      }
    }
  };
  const moreInfoDivText = (
    <div className='more-info'>
      רק רגע, הת"ז הזה לא מסתדר עם מה שיש
      <br />
      אצלנו. כדאי לנסות שוב{' '}
    </div>
  );
  const moreInfoDivMobile = (
    <div className='more-info'>
      רק רגע, הת"ז הזה לא מסתדר עם מה שיש אצלנו.
      <br />
      כדאי לנסות שוב{' '}
    </div>
  );
  const moreInfoDiv = isMobile ? moreInfoDivMobile : moreInfoDivText;
  const secondaryText = props.selectedLobby === lobbySelection.PRIVATE ? 'מה מספר הת.ז / ח.פ שלך?' : 'מה מספר הת.ז שלך?';
  const textPlaceholder = props.selectedLobby === lobbySelection.PRIVATE ? 'מספר ת.ז / ח.פ' : 'מספר ת.ז';
  return (
    <div className='screenContainer'>
      <form
        action='#'
        onSubmit={async (e) => {
          e.preventDefault();
          await validateId();
        }}>
        <Image src={mainLogo} />
        <h3 className='heading'>ת.ז ומתקדמים</h3>
        <EnterIdPartial
          onChangeType={changeIdType}
          errorInForm={errorInForm}
          onChangeText={(e) => {
            const numberRegex = /^\d+$/;
            const passportRegex = /^[A-Za-z0-9]{0,12}$/;
            if (
              (!isPassportInsert && (numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 9) ||
              (isPassportInsert && (e.target.value === '' || passportRegex.test(e.target.value)))
            ) {
              setIdNumber(e.target.value);
              setErrorForm(null);
              return true;
            }
            return false;
          }}
        />
        {/*<TextInput
          placeholder={textPlaceholder}
          value={idNumber}
          maxLength={'9'}
          type='text'
          inputMode='numeric'
          error={errorInForm}
          onChange={(e) => {
            const numberRegex = /^\d+$/;
            if ((numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 9) {
              setIdNumber(e.target.value);
              setErrorForm(null);
            }
          }}
        /> */}
        {moreInfo && moreInfoDiv}
        <Footer onclick={() => {}} stage={props.stage} />
      </form>
    </div>
  );
};

export default IdInsert;
